import script from "./TypeAhead.vue?vue&type=script&lang=ts&setup=true"
export * from "./TypeAhead.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__